<nav class="navbar">
  <div class="mobile-menu-overlay" [class.open]="isMobileMenuOpen()" (click)="toggleMobileMenu()"></div>

  <div class="nav-left">
    <a routerLink="/dashboard" class="nav-logo-link" (click)="closeMobileMenu()">
      <div class="nav-logo">
        <img src="assets/icons/logo_ei_fondo_azul.svg" alt="Logo" class="logo-img" />
      </div>
      <div class="nav-brand">
        <span class="brand-name">{{ 'navbar.brand' | translate }}</span>
        <span class="brand-role">{{ 'navbar.role' | translate }}</span>
      </div>
    </a>

    <ul class="nav-links" [class.mobile-open]="isMobileMenuOpen()">
      <li class="mobile-menu-header">
        <a routerLink="/dashboard" (click)="closeMobileMenu()">
          <img src="assets/icons/logo_ei_fondo_azul.svg" alt="Logo" class="mobile-logo-img" />
          <div class="mobile-brand">
            <span class="mobile-brand-name">{{ 'navbar.brand' | translate }}</span>
            <span class="mobile-brand-role">{{ 'navbar.role' | translate }}</span>
          </div>
        </a>
      </li>

      <li>
        <a routerLink="/tickets" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }" (click)="closeMobileMenu()">
          <mat-icon class="material-symbols-outlined">confirmation_number</mat-icon>
          Tickets
        </a>
      </li>

      <li class="mobile-user-actions">
        <div class="mobile-theme-section">
          <span class="mobile-theme-label">{{ 'navbar.theme' | translate }}</span>
          <div class="theme-switch">
            <button class="theme-switch-btn" [class.active]="themeService.mode() === 'light'" (click)="setTheme('light'); closeMobileMenu()">
              <mat-icon class="material-symbols-outlined">light_mode</mat-icon>
            </button>
            <button class="theme-switch-btn" [class.active]="themeService.mode() === 'system'" (click)="setTheme('system'); closeMobileMenu()">
              <mat-icon class="material-symbols-outlined">contrast</mat-icon>
            </button>
            <button class="theme-switch-btn" [class.active]="themeService.mode() === 'dark'" (click)="setTheme('dark'); closeMobileMenu()">
              <mat-icon class="material-symbols-outlined">dark_mode</mat-icon>
            </button>
            <div class="theme-slider" [ngClass]="themeService.mode()"></div>
          </div>
        </div>

        <div class="mobile-language-section">
          <span class="mobile-theme-label">{{ 'navbar.language' | translate }}</span>
          <div class="language-toggle" (click)="toggleLanguage()">
            <span class="lang-option" [class.active]="translationService.current() === 'es'">ES</span>
            <span class="lang-divider">|</span>
            <span class="lang-option" [class.active]="translationService.current() === 'en'">EN</span>
          </div>
        </div>

        <div class="mobile-username">
          <mat-icon class="material-symbols-outlined">account_circle</mat-icon>
          <span>{{ userName }}</span>
        </div>
        <div class="mobile-logout" (click)="logout()">
          <mat-icon class="material-symbols-outlined">logout</mat-icon>
          <span>{{ 'navbar.logout' | translate }}</span>
        </div>
      </li>
    </ul>
  </div>

  <div class="nav-user" (click)="toggleUserMenu($event)">
    <div class="nav-user-icon">
      <span class="user-name-desktop">{{ userName }}</span>
      <mat-icon class="material-symbols-outlined">account_circle</mat-icon>
    </div>

    <div class="user-menu" [class.active]="isUserMenuOpen()" (click)="onUserMenuClick($event)">
      <div class="user-menu-section">
        <span class="theme-label">{{ 'navbar.theme' | translate }}</span>
        <div class="theme-switch">
          <button class="theme-switch-btn" [class.active]="themeService.mode() === 'light'" (click)="setTheme('light'); $event.stopPropagation()">
            <mat-icon class="material-symbols-outlined">light_mode</mat-icon>
          </button>
          <button class="theme-switch-btn" [class.active]="themeService.mode() === 'system'" (click)="setTheme('system'); $event.stopPropagation()">
            <mat-icon class="material-symbols-outlined">contrast</mat-icon>
          </button>
          <button class="theme-switch-btn" [class.active]="themeService.mode() === 'dark'" (click)="setTheme('dark'); $event.stopPropagation()">
            <mat-icon class="material-symbols-outlined">dark_mode</mat-icon>
          </button>
          <div class="theme-slider" [ngClass]="themeService.mode()"></div>
        </div>
      </div>

      <div class="user-menu-divider"></div>

      <div class="user-menu-section">
        <span class="theme-label">{{ 'navbar.language' | translate }}</span>
        <div class="language-pill" (click)="toggleLanguage(); $event.stopPropagation()">
          <span class="lang-option" [class.active]="translationService.current() === 'es'">ES</span>
          <span class="lang-divider">|</span>
          <span class="lang-option" [class.active]="translationService.current() === 'en'">EN</span>
        </div>
      </div>

      <div class="user-menu-divider"></div>
      <a class="user-menu-item logout-btn" (click)="logout()">
        <mat-icon class="material-symbols-outlined">logout</mat-icon>
        <span>{{ 'navbar.logout' | translate }}</span>
      </a>
    </div>
  </div>

  <button class="nav-toggle" (click)="toggleMobileMenu()" [class.active]="isMobileMenuOpen()">
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
    <span class="hamburger-line"></span>
  </button>
</nav>
